"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeGroupSchema = void 0;
exports.ContentTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/content.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentTypeGroup",
    "description": "ContentTypeGroup represents one of the following types: AppleImmersiveVideo, AudioClip, AudioEpisode, AudioSeason, AudioSeries, AuthorProfile, ContentCollection, EditorialList, EnergyDrink, EpisodeVideo, EventDetail, EventProfile, EventSeason, EventSeries, ExternalPerson, ExternalTeam, ExternalContent, Film, ImageGallery, Image, Immersive3DModel, Judge, LiveVideo, Location, Misc, OccasionCampaign, Occasion, OnsitePromotion, PartnerProfile, PersonProfile, Photographer, Playlist, PreviewClip, ProjectProfile, RallyDriver, RallyTeam, RecapVideo, ResultsAndStandings, Season, Show, Story, Tag, TeamProfile, TrailerVideo, TvCommercial, TvPartnerChannel, Video3D, VideoChannel, Video, Video360",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/apple-immersive-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-episodes.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/author-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/collections.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/editorial-lists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/energy-drinks.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/episode-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-details.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/external-persons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/external-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/externals.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/films.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/image-galleries.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/images.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/immersive-3d-models.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/judges.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/live-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/locations.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/misc.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/occasion-campaigns.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/occasions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/onsite-promotions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/partner-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/person-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/photographers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/playlists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/preview-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/project-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/rally-drivers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/rally-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/recap-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/results-standings.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/shows.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/stories.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/tags.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/team-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/trailer-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/tv-commercials.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/tv-partner-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/video-3d.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/video-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/videos-360.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy90eXBlLWdyb3Vwcy9jb250ZW50LnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHNCQUFzQixHQUFHO0lBQ3BDLEtBQUssRUFBRSxpRUFBaUU7SUFDeEUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsa0JBQWtCO0lBQzNCLGFBQWEsRUFBRSxzckJBQXNyQjtJQUNyc0IsT0FBTyxFQUFFO1FBQ1A7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsNEVBQTRFO1NBQ3JGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsaUVBQWlFO1NBQzFFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsa0VBQWtFO1NBQzNFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUscUVBQXFFO1NBQzlFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsaUVBQWlFO1NBQzFFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUscUVBQXFFO1NBQzlFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsa0VBQWtFO1NBQzNFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsc0VBQXNFO1NBQy9FO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsK0RBQStEO1NBQ3hFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsMkRBQTJEO1NBQ3BFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUscUVBQXFFO1NBQzlFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsNERBQTREO1NBQ3JFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUseUVBQXlFO1NBQ2xGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsNERBQTREO1NBQ3JFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsaUVBQWlFO1NBQzFFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsK0RBQStEO1NBQ3hFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsMERBQTBEO1NBQ25FO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsd0VBQXdFO1NBQ2pGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsK0RBQStEO1NBQ3hFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsdUVBQXVFO1NBQ2hGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsc0VBQXNFO1NBQy9FO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUscUVBQXFFO1NBQzlFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsK0RBQStEO1NBQ3hFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsc0VBQXNFO1NBQy9FO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsaUVBQWlFO1NBQzFFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsa0VBQWtFO1NBQzNFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsdUVBQXVFO1NBQ2hGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsNkRBQTZEO1NBQ3RFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsMkRBQTJEO1NBQ3BFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsNkRBQTZEO1NBQ3RFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsMERBQTBEO1NBQ25FO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsbUVBQW1FO1NBQzVFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUseUVBQXlFO1NBQ2xGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsOERBQThEO1NBQ3ZFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0VBQW9FO1NBQzdFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsNERBQTREO1NBQ3JFO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsZ0VBQWdFO1NBQ3pFO0tBQ0Y7Q0FDRixDQUFBIn0=